<template>
  <div id="account-modal" class="modal-container" :class="{visible: visible}" :data-active-pane="currentView.pane" :data-active-page="currentView.page" @click="hide">

    <div class="modal side full-height" @click.stop>

      <div class="inner">

        <button type="button" class="circled interactive grey close-modal" @click="hide">
          <svg-icon id="cross"></svg-icon>
        </button>

        <component :is="user.type + '-account-panel'" v-if="user && user.type"></component>

      </div>
      <!-- /.inner -->

    </div>
    <!-- /.modal -->

  </div>
</template>

<script>
import HirerAccountPanel from './hirer/AccountPanel'
import ListerAccountPanel from './lister/AccountPanel'

export default {
  components: {
    HirerAccountPanel,
    ListerAccountPanel,
  },
  props: {
    formOptions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },

  computed: {

    currentView () {
      return this.$store.getters['account/current']
    },

    previousView () {
      return this.$store.getters['account/from']
    },

    user () {
      return this.$store.getters['user/account']
    },

    visible () {
      return this.$store.getters['account/visible']
    }

  },

  methods: {

    hide () {
      if(window.location.href.includes("#my-account")) {
        window.history.pushState("state obj or string", "url", window.location.href.substring(0, window.location.href.indexOf('#')));
      }
      this.$store.commit('account/hide', true)
    },

  }
}
</script>
